"use client";
import { Helmet } from "react-helmet";
import Footer from "../components/default/Footer";
import LoadingScreen from "../common/loader";
import ProgressScroll from "../components/default/ProgressScroll";
import Header from "../components/default/projects/project-web-rsg-dashten/Header";
import Next from "../components/default/projects/project-web-rsg-dashten/Next";
import Story from "../components/default/projects/project-web-rsg-dashten/Story";
import ArchiveHeaderTrans from "../components/default/ArchiveHeaderTrans";

export default function ProjectWebRsgDashten() {
  return (
    <>
      <Helmet>
        <title>Archives | Digital Platforms</title>
        <link rel="icon" href="/dark/imgs/nav/favicon.ico" />
        <link rel="shortcut icon" href="/dark/imgs/nav/favicon.ico" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/dark/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/dark/assets/css/style.css"
        />
      </Helmet>
      <body>
        <LoadingScreen />
        <ProgressScroll />
        <div id="smooth-wrapper">
          <div id="smooth-content">
            <main className="main-bg">
              <ArchiveHeaderTrans />
              <Header />
              <Story />
              <Next />
            </main>
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}
